export const Stipendiary = 'Stipendiary';

export const NonStipendiary = 'Non-Stipendiary';

export const Ok = 'ok';

export const Complete = 'Complete';

export const MissingInformation = 'missing_information';

export const OkNotEnrolled = 'ok_not_enrolled';

export const ErrorStatus = 'error_status';

export const MissingInfoNotEnrolled = 'missing_information_not_enrolled';

export const MissingInfoAndNotEnrolled = 'Missing Info And Not Enrolled';

export const CompleteAndNotEnrolled = 'Complete And Not Enrolled';

export const CompleteAndMissingInfo = 'Complete And Missing Info';

export const ErrorStatusInfo = 'Error Getting Status';

export const MissingInfo = 'Missing Info';

export const ProfileKey = 'https://oidc.cpg.org/profile';

export const Roles = 'roles';

export const EmployeeRoster = 'EmployeeRoster';

export const SeniorOfficer = 'SeniorOfficer';

export const AdminOfficer = 'AdminOfficer';

export const Yes = 'Yes';

export const No = 'No';

export const InstitutionRoster = 'InstitutionRoster';

export const DiocesanAdministrator = 'DiocesanAdministrator';

export const DiocesanAssociateAdministrator = 'DiocesanAssociateAdministrator';

export const MLPS = 'MLPS';

export const WAM = 'WAM';

export const JuniorGroupPlanAdmin = 'JuniorGroupPlanAdmin';

export const SeniorGroupPlanAdmin = 'SeniorGroupPlanAdmin';

export const WAMSuperAdmin = 'WAM_SuperAdmin';

export const DiocesanReports = 'DiocesanReports';

export const AccessArrearsReport = 'AccessArrearsReport';

export const AccessClergyLayCompReports = 'AccessClergyLayCompReports';

export const AccessImputedIncomeReport = 'AccessImputedIncomeReport';

export const Percent = 'percent';

export const Amount = 'amount';
export const SelectedFiles = 'Selected files';

export const Completed = 'Completed';
export const PendingSubmission = 'Pending Submission';
export const IfApplicable = 'If Applicable';
export const InProgress = 'In Progress';
export const NotStarted = 'Not Started';

export const Retiree = 'Retiree Certification';
export const PersonalInfo = 'Personal Info';
export const Relationships = 'Relationships';
export const Coverage = 'Coverage';
export const Review = 'Review';

export const ClergyTypeDefaultLabel = 'Clergy Type';
export const EmploymentTypeDefaultLabel = 'Employment Type';
export const EmploymentCompensation = 'Employment & Compensation';
export const NonStipPosition = 'Non-Stipendiary Position';

export const None = 'None';

export const UnitedStatesCountryCode = '1';

export const UnitedStatesISOCountryCode = 'US';

export const MaxCharacter255 = 'Max 225 characters';

export const NA = 'N/A';

export const createNewForm = 'createNewForm';

export const NewHireEventType = 'new_hire';

export const HoursIncreaseEventType = 'hours_increase_over_1000';

export const CoverageLoadErrorMessage = 'The approval window for this form has closed. Please submit employee enrollments through the Coverage screen instead.';
export const clergyDisabilityMessage = 'Effective January 1, 2026, clergy will no longer be a covered class under the AFLAC Plans and should not be enrolled in the Fully Insured Short- or Long-Term Disability plans.';
export const dependentCoverageBlockedMessage = 'Dependents aged 65 or older may not be eligible for coverage on your plan.';